import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import HubSpotDealList from "./HubSpotDealList";
import { ModalPickerProps } from "../props";

const HubSpotDealModalPicker = (props: ModalPickerProps<server.dto.HubSpotDeal>) => {
  const onChange = (value: server.dto.HubSpotDeal) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };
  return <ModalPickerWithChooseButton
    onNewClicked={() => { }}
    buttonLabel={"Link HubSpot deal"}
    modalTitle={"HubSpot deals"}
    modalSize="tiny"
    renderModalContent={(closeModal) => <HubSpotDealList
      onItemSelected={(deal) => {
        closeModal();
        onChange(deal);
      }}
    />}
    renderRemovable={() => <></>}

    {...props}
  />;
};

export default HubSpotDealModalPicker;